module.exports = "/assets/rwp-main-hand.png?jAhyJod";